import { AgentTypesResponse } from "@/types/agent"
import { GenerationDetail, GenerationListItem } from "@/types/email-previews"

import { baseApi } from "./base-api"

export type EmailPreviewType = "behavioral" | "welcome"
export type HotelBookingEmailType =
  | "hotel_booking_confirmation"
  | "hotel_booking_cancellation"

export type HotelBookingEmailRecipient = "owner" | "traveler"

export type HotelBookingEmailPreview = {
  booking_ref: string
  email_type: HotelBookingEmailType
  recipient: HotelBookingEmailRecipient
  subject: string | null
  html: string
}

export const emailPreviewsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailGenerations: builder.query<
      { generations: GenerationListItem[] },
      EmailPreviewType
    >({
      query: (emailType) => ({
        url: `/api/emails/${emailType}/generations`,
      }),
      providesTags: (_result, _error, emailType) => [
        { type: "EmailGeneration", id: `${emailType}-list` },
      ],
    }),
    getEmailGeneration: builder.query<
      GenerationDetail,
      { emailType: EmailPreviewType; id: string | number }
    >({
      query: ({ emailType, id }) => ({
        url: `/api/emails/${emailType}/generations/${id}`,
      }),
      providesTags: (_result, _error, { emailType, id }) => [
        { type: "EmailGeneration", id: `${emailType}-${id}` },
      ],
    }),
    getEmailToolAgentTypes: builder.query<AgentTypesResponse, void>({
      query: () => ({ url: "/api/agent/types" }),
    }),
    getHotelBookingEmailPreview: builder.query<
      HotelBookingEmailPreview,
      {
        emailType: HotelBookingEmailType
        bookingRef: string
        recipient: HotelBookingEmailRecipient
      }
    >({
      query: ({ emailType, bookingRef, recipient }) => ({
        url: `/api/emails/${emailType}/preview`,
        params: { booking_ref: bookingRef, recipient },
      }),
    }),
  }),
})

export const {
  useGetEmailGenerationQuery,
  useGetEmailGenerationsQuery,
  useGetEmailToolAgentTypesQuery,
  useGetHotelBookingEmailPreviewQuery,
} = emailPreviewsApi
